import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {state} from 'lit/decorators/state.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';

import down from '../../../icons/down';
import info from '../../../icons/info';

import store from '../../store';

import {staggeredReveal, widgetButton} from '../../css/styleSets';
import {setIomoCustomColorUse} from '../iomoSlice';
import {selectIomoColorTheme, selectIomoColorThemeIsSatisfied, selectIomoCustomColor, selectIomoCustomColorUse} from '../iomoSelectors';
import {iomoColorEditionOptions} from '../iomoMaterial';

@customElement('color-editions')
export class ColorEditions extends connect(store)(LitElement) {

	static styles = [
		staggeredReveal,
		widgetButton,
		css`
			:host {
				background: var(--color-widget-background);
				padding: var(--very-small-padding);
				display: flex;
				flex-direction: column;
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}
			.buttons {
				display: flex;
				flex-direction: row;
				margin-bottom: var(--padding);
			}
			.selected {
				background-color: var(--color-widget-background-selected);
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(s) {
		this.lang = s.status.lang;
		this.loggedIn = s.userProfile.data.loggedIn;
		this.useCustomColor = selectIomoCustomColorUse(s);
	}

	useCustom() {
		store.dispatch(setIomoCustomColorUse({use: true}));
	}
	useCurated() {
		store.dispatch(setIomoCustomColorUse({use: false}));
	}
	render() {
		const s = store.getState();
		return html`
			<div>
				<div class="title">
					<span class="headline">${msg('Surface')}</span>
				</div>
				<div class="buttons">
					<button @click=${this.useCurated} class="${classMap({selected: !this.useCustomColor})}">${msg('Curated Editions')}</button>
					<button @click=${this.useCustom} class="${classMap({selected: this.useCustomColor})}">${msg('Custom Colors')}</button>
				</div>

				${when(this.useCustomColor,
					() => html`
						<custom-color-select></custom-color-select>
					`,
					() => html`
						<color-editions-select
							.options=${iomoColorEditionOptions}
							action='iomo/setIomoColorTheme'
							.selected=${selectIomoColorTheme}
							.canBeSelected=${() => true}
							.isSatisfied=${selectIomoColorThemeIsSatisfied}>
						</color-editions-select>
					`
				)}

			</div>
		`;
	}
}
